// src/ConsumerApp/api/location/location.service.js

const API_BASE_URL = (
  process.env.REACT_APP_BASE_URL || 'https://backend.brickbucket.in/'
).replace(/\/+$/, '');

export const LocationService = {
  /**
   * Reverse-geocodes coordinates via the backend proxy[cite: 20].
   */
  reverseGeocode: async (lat, lng) => {
    try {
      const response = await fetch(`${API_BASE_URL}/reverse-geocode`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ lat, lng }),
      });

      if (!response.ok) {
        throw new Error(`Geocoding HTTP error ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.warn('Backend Geocoding Warning:', error.message);
      return {
        status: 'ERROR_HANDLED',
        results: [
          {
            formatted_address: 'Address unavailable. Please enter manually.',
            address_components: [{ long_name: 'Unknown Location', types: ['locality'] }],
          },
        ],
        data: {
          fullAddress: 'Address unavailable. Please enter manually.',
          city: 'Unknown Location',
        },
      };
    }
  },

  /**
   * Fetches Google Places autocomplete predictions from the backend proxy[cite: 20].
   */
  searchPlaces: async (input, sessiontoken) => {
    try {
      const url = `${API_BASE_URL}/places-search?input=${encodeURIComponent(
        input
      )}&sessiontoken=${sessiontoken}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) {
        throw new Error(`Search HTTP error ${response.status}`);
      }

      const json = await response.json();
      return json?.predictions || json?.data?.predictions || [];
    } catch (error) {
      console.warn('Backend Places Search Error:', error);
      return [];
    }
  },

  /**
   * Fetches specific place details from the backend proxy[cite: 20].
   */
  getPlaceDetails: async (placeId, sessiontoken) => {
    try {
      const url = `${API_BASE_URL}/place-details?placeId=${placeId}&sessiontoken=${sessiontoken}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) {
        throw new Error(`Place details HTTP error ${response.status}`);
      }

      const json = await response.json();
      return json?.result || json?.data?.result || json;
    } catch (error) {
      console.error('Backend Place Details Error:', error);
      throw error;
    }
  },
};